import React from "react";

export const camaraUrl = "https://dadosabertos.camara.leg.br/api/v2";

const url_params = (url, params) => {
  if (!params || Object.keys(params).length === 0) return url;
  return `${url}?${new URLSearchParams(params)}`;
};

export const fetchCamara = (endpoint, params) =>
  fetch(`${camaraUrl}/${url_params(endpoint, params)}`)
    .then((r) => r.json())
    .then((r) => r?.dados);

export const useFetchCamara = (endpoint, params) => {
  const [response, setResponse] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    fetchCamara(endpoint, params)
      .then(setResponse)
      .catch(setError)
      .finally(() => setLoading(false));
  }, [endpoint, params]);

  return { data: response, setData: setResponse, error, loading };
};

export const useInfiniteCamara = (endpoint, items, params) => {
  const [data, setData] = React.useState([]);
  const [pagina, setPagina] = React.useState(1);

  React.useEffect(() => {
    setPagina(1);
    setData([]);
  }, [params]);

  const fetchParams = React.useMemo(
    () => ({
      ...(params && { ...params }),
      itens: items || 10,
      pagina,
    }),
    [pagina, items, params]
  );

  const { data: fetchedData, loading, error } = useFetchCamara(endpoint, fetchParams);

  const iObserver = React.useRef(null);
  React.useEffect(() => {
    iObserver.current = new IntersectionObserver(([{ isIntersecting }]) => {
      isIntersecting && setPagina((p) => p + 1);
    });
  }, []);

  //Observed Item Logic
  const [observedItem, setObservedItem] = React.useState(null);
  React.useEffect(() => {
    const currItem = observedItem;
    const currObserver = iObserver.current;
    currItem && currObserver && currObserver.observe(currItem);
    return () => currItem && currObserver.unobserve(currItem);
  }, [observedItem]);

  //data accumulation logic
  React.useEffect(() => {
    fetchedData && !loading && setData((list) => [...list, ...fetchedData]);
  }, [fetchedData, loading]);

  return { data, loading, empty: !data?.length, error, observerRef: setObservedItem };
};
